import React from 'react';
import { useTranslation } from 'react-i18next';
import { setColorWithOpacityCss } from '../../utils/setColorWithOpacityCss';
import * as Styled from './PageHeader.styled';
import { NextImg } from '../../atoms/NextImg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The `PageHeader` content block displays relevant information to the user, particularly the non-profit
 * organization (NPO) to whom they are donating.
 *
 * The `Logo` placeholder will be replaced by an image uploaded by the user.
 */
export const PageHeader = _ref => {
  let {
    cssBackgroundColor,
    cssBackgroundColorOpacity,
    logoAssetUrl,
    logoAltText = '',
    logoLink = '',
    logoLinkOpensNewTab,
    hidePlaceholder = false,
    orgName,
    NextImage,
    isSticky = false,
    children,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation('blocks.pageHeader');
  const orgNameOrAltText = orgName || logoAltText;
  return /*#__PURE__*/_jsxs(Styled.Header, {
    isSticky: isSticky,
    cssBackgroundColor: setColorWithOpacityCss(cssBackgroundColor, cssBackgroundColorOpacity),
    ...rest,
    children: [!logoAssetUrl && !hidePlaceholder && /*#__PURE__*/_jsx(Styled.BlockPlaceholder, {
      children: t('PageHeader.logo.placeholder', 'Logo')
    }), logoAssetUrl && /*#__PURE__*/_jsx("a", {
      href: logoLink || undefined,
      role: !logoLink ? 'presentation' : undefined,
      target: logoLinkOpensNewTab ? '_blank' : undefined,
      rel: "noopener noreferrer",
      title: t('PageHeader.logoLink.title', {
        orgNameOrAltText,
        defaultValue: '{{orgNameOrAltText}} home'
      }),
      children: /*#__PURE__*/_jsx(NextImg, {
        NextImage: NextImage,
        src: logoAssetUrl,
        alt: t('PageHeader.logo.alt', {
          orgNameOrAltText,
          defaultValue: '{{orgNameOrAltText}} logo'
        }),
        height: "600",
        width: "600"
      })
    }), /*#__PURE__*/_jsx(Styled.ItemsContainer, {
      children: children
    })]
  });
};